<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow mt-0">

            <div
              class="card-header card-header-primary negative blue-grad w-50 d-flex"
            >
              <button
                class="btn btn-sm btn-link"
                @click="$router.go(-1)"
              >
                <i class="fa fa-chevron-left"></i>
                {{ $t("message.back") }}
              </button>

              <h4 class="card-title">
                {{ $t("message.admin.admin_user_balance.user_balance") }}
              </h4>
            </div>

            <div class="card-body px-3">
              <div class="row">
                <div class="col-12">

                  <hypertable
                    :show_pdf="false"
                    request="/admin/UsageReportUsers"
                    :fields="fields"
                    :pagination_through_total_count="true"
                    :client_companies_list="client_companies_list"
                    :show_filter_date="false"
                    :clickable="true"
                    @row-clicked="openUserHistory"
                  />

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import hypertable from "../hypertable.vue";

export default {
  name: "AdminUsageReportUsers",

  components: {
    hypertable,
  },

  data() {
    return {
      client_companies_list: [],

      fields: [
        {
          key: "row_no",
          label: this.$t("message.admin.admin_user_balance.row_no"),
          sortable: false,
          summable: false,
        }, {
            key: "org_name",
            label: this.$t("message.admin.admin_user_balance.organization_name"),
            sortable: false,
            summable: false,
            formatter: (value, key, item) => {
              return value || item.org_id;
            },
        }, {
            key: "total_top_up",
            label: this.$t("message.admin.admin_user_balance.total_top_up"),
            sortable: false,
            summable: true,
        }, {
            key: "total_spent",
            label: this.$t("message.admin.admin_user_balance.total_spent"),
            sortable: false,
            summable: true,
        }, {
            key: "balance",
            label: this.$t("message.admin.admin_user_balance.balance"),
            sortable: false,
            summable: true,
        }, {
            key: "last_operation_date",
            label: this.$t("message.admin.admin_user_balance.last_operation_date"),
            sortable: true,
            summable: false,
        }
      ]
    };
  },

  mounted() {
    if (!this.$store.state.auth) {
      this.$router.push({
        name: "sign-in",
      });

      return;
    }

    this.get_filter_values();
  },

  methods: {
    openUserHistory(user) {
      this.$router.push({
        name: "admin-usage-report-user-history",
        params: {
          org_id: user.org_id,
          org_name: user.org_name,
        },
      });
    },

    get_filter_values() {
      axios
        .get(window.base + "/admin/UsageReportApiClientCompanyNamesFull")
        .then((response) => {
          this.client_companies_list = response.data;

          this.client_companies_list.forEach(element => {
            if (element.value === null || element.value === "") {
              element.value = element.key;
            }
          });
        });
    },
  },
};
</script>

<style type="text/css">
.hyper-table tbody tr {
  cursor: pointer;
}

.vs--single .vs__selected {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
}
</style>